import React from 'react';
import SurveyChart from './SurveyChart';
import SurveyTable from './SurveyTable';
import { useWatch } from 'react-hook-form';

const RESPONSE_HEADER_TEXT = 'Responses by Year %';

/**
 * @typedef {object} SurveyResultsSectionProps
 * @property {boolean} loading
 * @property {boolean} isEditMode
 */

/**
 * @param {SurveyResultsSectionProps} props
 */
const SurveyResultsSection = props => {
  const { loading, isEditMode } = props;
  const questions = useWatch({ name: `questions` });
  return (
    <>
      {questions.map(question => {
        const questionIndex = questions.findIndex(x => x.Id === question.Id);
        return (
          <div key={question.Id} className='survey-results__chart-and-table'>
            <h3>{question.Question}</h3>
            <h2 className='survey-results__response-header'>{RESPONSE_HEADER_TEXT}</h2>
            <SurveyChart surveyResults={question.SurveyResults} />
            <SurveyTable
              surveyResults={question.SurveyResults}
              isEditMode={isEditMode}
              loading={loading}
              questionIndex={questionIndex}
            />
          </div>
        );
      })}
    </>
  );
};

export default SurveyResultsSection;
